import { css } from "@emotion/css";

import { ActionListItem } from "../../action-list/ActionListItem";
import { CheckboxControl } from "../../inputs/checkbox/CheckboxControl";
import { RadioControl } from "../../inputs/radio/RadioControl";

interface Props {
  isSelected?: boolean;
  leading?: React.ReactNode;
  selectionMode?: "none" | "single" | "multiple";
  subtitle?: string;
  testID: string;
  title: string;
  truncateTitle?: boolean;
  isDisabled?: boolean;
  minimizePadding?: boolean;
}

export function PickerListItem(props: Props) {
  const {
    subtitle,
    isSelected,
    selectionMode: mode,
    truncateTitle,
    isDisabled,
    minimizePadding,
  } = props;

  const trailing =
    mode === "single" ? (
      <RadioControl isSelected={isSelected} isDisabled={isDisabled} />
    ) : mode === "multiple" ? (
      <CheckboxControl isSelected={isSelected} isDisabled={isDisabled} />
    ) : undefined;

  return (
    <ActionListItem
      alignItems="center"
      className={
        minimizePadding
          ? css({
              paddingTop: "var(--space-2)",
              paddingBottom: "var(--space-2)",
            })
          : undefined
      }
      leading={props.leading}
      testID={props.testID}
      title={props.title}
      titleStyle="global/body-list"
      trailing={trailing}
      truncateTitle={truncateTitle}
    >
      {subtitle}
    </ActionListItem>
  );
}
